/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMonitor: {
  name: 'monitor';
  data: string;
} = {
  name: 'monitor',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7v2h4a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h4v-2H4a2 2 0 0 1-2-2V5Zm18 10H4V5h16v10Z" fill="currentColor"/></svg>`,
};
